import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { sprintf } from 'sprintf-js';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

export interface CustomField {
  id: number;
  label: string;
  location: string;
  field_type: string;
  picklist_values: string[];
  display: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class CustomFieldService extends BaseService {
  constructor(protected override http: HttpClient) {
    super(http, `${environment.apiBaseUrl}/companies/%(company_id)s/custom_fields`);
  }

  list(urlParams: { company_id: string }): Observable<CustomField[]> {
    const url = sprintf(`${environment.apiBaseUrl}/companies/%(company_id)s/custom_fields`, urlParams);
    return this.http.get<CustomField[]>(url);
  }

  create(payload: Partial<CustomField> & { picklist?: string }, urlParams: { company_id: string }): Observable<CustomField> {
    const url = sprintf(`${environment.apiBaseUrl}/companies/%(company_id)s/custom_fields`, urlParams);
    return this.http.post<CustomField>(url, payload);
  }

  update(
    id: number,
    payload: Partial<CustomField> & { picklist_values?: string[] | string },
    urlParams: { company_id: string },
  ): Observable<CustomField> {
    const url = sprintf(`${environment.apiBaseUrl}/companies/%(company_id)s/custom_fields/${id}`, urlParams);
    return this.http.put<CustomField>(url, payload);
  }
}
